module.exports = __webpack_public_path__ + "static/media/tutorial-wounds-1.f49b1bf1.png";